import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import persistState from "redux-localstorage";
// Each Reducer
import userReducer from "./userDucks";
import databaseReducer from "./dbDucks";
import hospitalReducer from "./hospitalDucks";
import distributorReducer from "./distributorDucks";

const rootReducer = combineReducers({
  user: userReducer,
  database: databaseReducer,
  hospital: hospitalReducer,
  distributor: distributorReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Instancia unica: fuera de React para que las peticiones puedan leer el token
// de la sesion sin pasar por un componente.
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk), persistState()));

export default function generateStore() {
  return store;
}

export { store };
